import Vue from 'vue'
import XEUtils from 'xe-utils'
import store from '@/store'
import constant from '@/utils/constant'

// 是否有权限
let hasControl = (list) => {
  let selfAccountData = store.getters.getLoginAccount
  if (selfAccountData.isAdmin) return true // 管理员
  if (!list || !list.length) return true // 没传入权限数据
  let actionKeyList = selfAccountData.actionKeyList
  let result = list.some((item) => {
    return actionKeyList.some((key) => {
      // || key.indexOf(`${item}`) > -1
      let res =
        key && (key.indexOf(`/admin/gcvip${item}`) > -1 || key.indexOf(`/admin${item}`) > -1)
      return res
    })
  })

  return result
}

// 列表累加总计
let listAddTotal = (list, field) => {
  let listCount = list.map((item) => {
    return field ? item[field] : item
  })
  return XEUtils.sum(listCount)
}

// 表格选择提示
let tableChoosePrompt = () => {
  Vue.prototype.$message.error('请先选择表格数据项，再进行操作')
}

// 自动生成
let autoGenerate = (val) => {
  return val || '自动生成'
}

// 英文符号分隔
let useEnSymbolFenGe = (val = '') => {
  let result = val ? `英文"${val}"号分隔` : '请选择分隔符号'
  return result
}

// 获取单位
let getDanWei = (val) => {
  // val = 'kg,重量'
  let result = ''
  if (val) {
    let arr = val.split(',')
    let len = arr.length
    if (len) result = arr[0]
  }
  return result
}

/**
 * 获取合并单元格配置列表
 * @params {Array} tableData 表格数据
 * @params {Array} tableColumn 表格列
 * @params {String} fieldMatch 合并字段匹配
 * @returns {Array} result 合并结果
 *
 */
let getMergeCellConfigList = (tableData, tableColumn, fieldMatch) => {
  let result = [] // 合并-单元格
  let mergeList = [] // 合并-列表
  let mergeObj = null // 合并-项
  let mergeIdx = null // 合并-索引
  let mergeLen = null // 合并-行数
  tableData.forEach((rowItem, rowIndex) => {
    if (mergeObj) {
      if (mergeObj[fieldMatch] === rowItem[fieldMatch]) {
        mergeLen++
        if (rowIndex === tableData.length - 1) {
          mergeList.push({
            idx: mergeIdx,
            len: mergeLen
          })
        }
      } else {
        if (mergeLen > 1) {
          mergeList.push({
            idx: mergeIdx,
            len: mergeLen
          })
        }
        mergeObj = rowItem
        mergeIdx = rowIndex
        mergeLen = 1
      }
    } else {
      mergeObj = rowItem
      mergeIdx = rowIndex
      mergeLen = 1
    }
  })
  mergeList.forEach((mergeItem) => {
    tableColumn.forEach((colItem, colIndex) => {
      if (colItem.isMerge) {
        let obj = {
          row: mergeItem.idx, // 单元格-行位置
          col: colIndex, // 单元格-列位置
          rowspan: mergeItem.len, // 合并-行数
          colspan: 1 // 合并-列数
        }
        result.push(obj)
      }
    })
  })
  return result
}

// 获取合并全部单元格
let getMergeCellAll = (tableData, mergeIndex, mergeLength) => {
  let result = tableData.map((item, index) => {
    let obj = {
      row: index, // 单元格-行位置
      col: mergeIndex, // 单元格-列位置
      rowspan: 1, // 合并-行数
      colspan: mergeLength // 合并-列数
    }
    return obj
  })
  return result
}

/**
 * 获取合并数量列表通过名称匹配
 * @params {Array} list 列表
 * @params {String} name 合并匹配字段
 * @params {String} count 合并数量字段
 * @returns {Array} result 合并结果
 */
let getMergeCountListByName = (list, merge_str, merge_count) => {
  let result = Object.values(
    list.reduce((acc, obj) => {
      let initObj = { ...obj }
      initObj[merge_count] = 0

      let obj_str = obj[merge_str]
      if (!acc[obj_str]) acc[obj_str] = initObj
      acc[obj_str][merge_count] += obj[merge_count]

      return acc
    }, {})
  )
  return result
}

/**
 * 交货日期状态：按自然日计算距今天还有多少天/超期多少天，供列表展示"剩余/超期"文案与颜色
 * 使用场景：核算单、订单、工程协同、PMC、外协工单、生产任务等列表的"交货日期"列
 * @params {String|Number|Date} jiaoHuoDate 交货日期，支持 'yyyy-MM-dd'、'yyyy-MM-dd HH:mm:ss'、时间戳、Date
 * @returns {Object} result
 *   result.text     展示文案：'剩余X天' / '今天到期' / '超期X天' / ''(空或非法日期)
 *   result.color    颜色标识：'green'(未到期) / 'blue'(当天到期) / 'red'(已超期) / ''(无日期)
 *   result.className 可直接绑定到 class 的颜色工具类：'c-green' / 'c-blue' / 'c-red' / ''
 *
 * 示例：getJiaoHuoDateStatus('2026-10-13') => { text: '剩余3天', color: 'green', className: 'c-green' }
 *       getJiaoHuoDateStatus('2026-10-10') => { text: '今天到期', color: 'blue',  className: 'c-blue'  }
 *       getJiaoHuoDateStatus('2026-10-05') => { text: '超期5天',  color: 'red',   className: 'c-red'   }
 */
let getJiaoHuoDateStatus = (jiaoHuoDate) => {
  let result = { text: '', color: '', className: '' }
  if (!jiaoHuoDate) return result
  // 字符串中的 '-' 替换为 '/'，避免部分浏览器把 'yyyy-MM-dd' 按 UTC 解析导致日期偏移一天
  let target =
    typeof jiaoHuoDate === 'string'
      ? new Date(jiaoHuoDate.replace(/-/g, '/'))
      : new Date(jiaoHuoDate)
  if (isNaN(target.getTime())) return result
  // 按自然日对比，忽略时分秒
  target.setHours(0, 0, 0, 0)
  let today = new Date()
  today.setHours(0, 0, 0, 0)
  let diffDay = Math.round((target.getTime() - today.getTime()) / 86400000)
  if (diffDay > 0) {
    result.text = `剩余${diffDay}天`
    result.color = 'green'
  } else if (diffDay === 0) {
    result.text = '今天到期'
    result.color = 'blue'
  } else {
    result.text = `超期${-diffDay}天`
    result.color = 'red'
  }
  result.className = `c-${result.color}`
  return result
}

// 获取列表字符串
let getListStr = (list, name = 'name', symbol = ',') => {
  let result = ''
  if (list) {
    let nameList = list.map((item) => item[name])
    result = nameList.join(symbol)
  }
  return result
}

/**
 * 公式结果
 * @params {Array} arrGs 数组公式
 * @params {Object} objCs 对象参数
 * @params {Object} objFh 对象符号
 * @returns {Number} result
 *
 */
let gongShiResult = (arrGs, objCs) => {
  let objFh = {
    '²': '**2',
    '³': '**3',
    π: '3.14159'
  }
  let listGs = JSON.parse(JSON.stringify(arrGs))
  listGs.forEach((item, index) => {
    // 替换参数
    Object.keys(objCs).forEach((key) => {
      if (item === key) {
        listGs[index] = objCs[key]
      }
    })
    // 替换符号
    Object.keys(objFh).forEach((key) => {
      if (item === key) {
        listGs[index] = objFh[key]
      }
    })
  })
  // let strOld = arrGs.join('')
  let strNew = listGs.join('') || '0'
  let result = eval(strNew)
  // console.log('--------分割线')
  // console.log('计算公式：', strOld)
  // console.log('计算参数：', strNew)
  // console.log('计算结果：', result)
  return result
}
// let arrGs = ['(', '外径', '-', '厚度', ')', '*', '厚度', '*', '密度', '*', '长度', '/', '1000']
// let objCs = { 外径: '10', 厚度: '1', 长度: '6000', 密度: '0.02491' }
// gongShiResult(arrGs, objCs)

// 规格是否含闭合括号（中文或英文）：含括号表示公式自动计算不准确，需手动输入
let hasBracket = (val) => /(\(.*\)|（.*）)/.test(String(val || ''))

// 开始校验
let actionVerify = (verifyData, selfData) => {
  // 规格含括号：跳过公式自动计算，保留手动输入值
  if (hasBracket(verifyData.gui_ge_shi_li)) return
  // 校验必填项------------------------------------------
  let requiredList = []
  if (!verifyData.gui_ge_shi_li) requiredList.push('规格示例')
  selfData.dan_wei_zu_list.forEach((itemSt) => {
    itemSt.gong_shi_list.forEach((itemNd) => {
      selfData.fu_jia_can_shu_list.forEach((itemRd, indexRd) => {
        if (itemRd.name === itemNd) {
          let isEmpty = !selfData.fu_jia_can_shu_shi_li[indexRd]
          let isNotRepeat = requiredList.every((itemTh) => itemTh !== itemNd)
          if (isEmpty && isNotRepeat) requiredList.push(itemNd)
        }
      })
    })
  })
  if (requiredList.length) {
    Vue.prototype.$message.error(`请输入${requiredList[0]}`)
    return
  }

  // 对象参数------------------------------------------
  let objCs = {
    密度: selfData.mi_du_shi_li
  }
  let guiGeShiLiList = verifyData.gui_ge_shi_li.split('*')
  selfData.gui_ge_list.forEach((item, index) => (objCs[item] = guiGeShiLiList[index]))
  selfData.fu_jia_can_shu_list.forEach((item, index) => {
    objCs[item.name] = selfData.fu_jia_can_shu_shi_li[index]
  })

  // 基础产量示例浮动处理------------------------------------------
  let resultChanLiangShuzhi = 0
  let resultChanLiangBili = 0
  let effectJiChuChanLiangList = []
  selfData.ji_chu_chan_liang_list.forEach((itemSt, indexSt) => {
    itemSt.forEach((itemNd) => {
      // 获取有效的浮动列表
      let resA =
        itemNd.tiao_zheng_key_list.length && itemNd.tiao_zheng_type && itemNd.tiao_zheng_val
      let resB = false
      if (indexSt) {
        resB = !!itemNd.tiao_zheng_scope_val
      } else {
        resB = itemNd.tiao_zheng_scope_start || itemNd.tiao_zheng_scope_end
      }
      if (resA && resB) {
        effectJiChuChanLiangList.push({ ...itemNd, type: indexSt })
      }
    })
  })
  effectJiChuChanLiangList.forEach((item) => {
    let resultComparePass = false
    // 0：参数范围
    if (item.type === 0) {
      let key = item.tiao_zheng_key_list[0]
      let tiaoZhengObj = {
        key: key,
        val: objCs[key]
      }
      let resultCompareS = Number(tiaoZhengObj.val) >= Number(item.tiao_zheng_scope_start) // 对比开始值
      let resultCompareE = Number(tiaoZhengObj.val) <= Number(item.tiao_zheng_scope_end) // 对比结束值
      if (item.tiao_zheng_scope_start && !item.tiao_zheng_scope_end) {
        resultComparePass = resultCompareS
      }
      if (!item.tiao_zheng_scope_start && item.tiao_zheng_scope_end) {
        resultComparePass = resultCompareE
      }
      if (item.tiao_zheng_scope_start && item.tiao_zheng_scope_end) {
        resultComparePass = resultCompareS && resultCompareE
      }
    }
    // 1：参数匹配
    if (item.type === 1) {
      let symbolStr = constant.pipeiSymbolList[0]
      constant.pipeiSymbolList.forEach((itemSymbol) => {
        if (item.tiao_zheng_scope_val.includes(itemSymbol)) symbolStr = itemSymbol
      })
      let piPeiList = item.tiao_zheng_scope_val.split(symbolStr)
      let tiaoZhengList = item.tiao_zheng_key_list.map((itemKey) => objCs[itemKey])
      let sortPiPeiList = piPeiList.sort((a, b) => a - b)
      let sortTiaoZhengList = tiaoZhengList.sort((a, b) => a - b)
      resultComparePass = sortPiPeiList.join(',') === sortTiaoZhengList.join(',')
    }

    if (!resultComparePass) return
    if (item.tiao_zheng_type === '0') {
      resultChanLiangShuzhi = XEUtils.add(resultChanLiangShuzhi, item.tiao_zheng_val) // 上调数值
    }
    if (item.tiao_zheng_type === '1') {
      resultChanLiangShuzhi = XEUtils.subtract(resultChanLiangShuzhi, item.tiao_zheng_val) // 下调数值
    }
    if (item.tiao_zheng_type === '2') {
      let result = XEUtils.multiply(verifyData.ji_chu_chan_liang, item.tiao_zheng_val / 100)
      resultChanLiangBili = XEUtils.add(resultChanLiangBili, result) // 上调比例
    }
    if (item.tiao_zheng_type === '3') {
      let result = XEUtils.multiply(verifyData.ji_chu_chan_liang, item.tiao_zheng_val / 100)
      resultChanLiangBili = XEUtils.subtract(resultChanLiangBili, result) // 下调比例
    }
  })
  verifyData.chan_liang_shi_li = verifyData.ji_chu_chan_liang // 产量示例
  verifyData.chan_liang_shi_li = XEUtils.add(verifyData.chan_liang_shi_li, resultChanLiangShuzhi) // 加数值
  verifyData.chan_liang_shi_li = XEUtils.add(verifyData.chan_liang_shi_li, resultChanLiangBili) // 加比例
  if (verifyData.chan_liang_shi_li) objCs['产量'] = verifyData.chan_liang_shi_li

  // 基础价格示例浮动处理------------------------------------------
  let resultJiJiaShuzhi = 0
  let resultJiJiaBili = 0
  let effectJiChuJiaGeList = []
  selfData.ji_chu_jia_ge_list.forEach((itemSt, indexSt) => {
    itemSt.forEach((itemNd) => {
      // 获取有效的浮动列表
      let resA =
        itemNd.tiao_zheng_key_list.length && itemNd.tiao_zheng_type && itemNd.tiao_zheng_val
      let resB = false
      if (indexSt) {
        resB = !!itemNd.tiao_zheng_scope_val
      } else {
        resB = itemNd.tiao_zheng_scope_start || itemNd.tiao_zheng_scope_end
      }
      if (resA && resB) {
        effectJiChuJiaGeList.push({ ...itemNd, type: indexSt })
      }
    })
  })
  effectJiChuJiaGeList.forEach((item) => {
    let resultComparePass = false
    // 0：参数范围
    if (item.type === 0) {
      let key = item.tiao_zheng_key_list[0]
      let tiaoZhengObj = {
        key: key,
        val: objCs[key]
      }
      let resultCompareS = Number(tiaoZhengObj.val) >= Number(item.tiao_zheng_scope_start) // 对比开始值
      let resultCompareE = Number(tiaoZhengObj.val) <= Number(item.tiao_zheng_scope_end) // 对比结束值
      if (item.tiao_zheng_scope_start && !item.tiao_zheng_scope_end) {
        resultComparePass = resultCompareS
      }
      if (!item.tiao_zheng_scope_start && item.tiao_zheng_scope_end) {
        resultComparePass = resultCompareE
      }
      if (item.tiao_zheng_scope_start && item.tiao_zheng_scope_end) {
        resultComparePass = resultCompareS && resultCompareE
      }
    }
    // 1：参数匹配
    if (item.type === 1) {
      let symbolStr = constant.pipeiSymbolList[0]
      constant.pipeiSymbolList.forEach((itemSymbol) => {
        if (item.tiao_zheng_scope_val.includes(itemSymbol)) symbolStr = itemSymbol
      })
      let piPeiList = item.tiao_zheng_scope_val.split(symbolStr)
      let tiaoZhengList = item.tiao_zheng_key_list.map((itemKey) => objCs[itemKey])
      let sortPiPeiList = piPeiList.sort((a, b) => a - b)
      let sortTiaoZhengList = tiaoZhengList.sort((a, b) => a - b)
      resultComparePass = sortPiPeiList.join(',') === sortTiaoZhengList.join(',')
    }

    if (!resultComparePass) return
    if (item.tiao_zheng_type === '0') {
      resultJiJiaShuzhi = XEUtils.add(resultJiJiaShuzhi, item.tiao_zheng_val) // 上调数值
    }
    if (item.tiao_zheng_type === '1') {
      resultJiJiaShuzhi = XEUtils.subtract(resultJiJiaShuzhi, item.tiao_zheng_val) // 下调数值
    }
    if (item.tiao_zheng_type === '2') {
      let result = XEUtils.multiply(verifyData.ji_chu_jia_ge, item.tiao_zheng_val / 100)
      resultJiJiaBili = XEUtils.add(resultJiJiaBili, result) // 上调比例
    }
    if (item.tiao_zheng_type === '3') {
      let result = XEUtils.multiply(verifyData.ji_chu_jia_ge, item.tiao_zheng_val / 100)
      resultJiJiaBili = XEUtils.subtract(resultJiJiaBili, result) // 下调比例
    }
  })
  verifyData.ji_jia_shi_li = verifyData.ji_chu_jia_ge // 基价示例
  verifyData.ji_jia_shi_li = XEUtils.add(verifyData.ji_jia_shi_li, resultJiJiaShuzhi) // 加数值
  verifyData.ji_jia_shi_li = XEUtils.add(verifyData.ji_jia_shi_li, resultJiJiaBili) // 加比例

  // 单位组-单位参数校验------------------------------------------
  selfData.dan_wei_zu_list.forEach((itemSt) => {
    // 主计量-单位参数校验
    let main_verify_unit_val = ''
    itemSt.dan_wei_list.forEach((itemNd) => {
      if (itemNd.is_zhu_ji_liang) {
        let result = ''
        if (itemSt.dan_wei_zu_name === '时间') {
          result = XEUtils.divide(1, verifyData.chan_liang_shi_li) // 使用：1/产量示例
        } else {
          result = tool.gongShiResult(itemSt.gong_shi_list, objCs) // 使用：公式计算
        }
        itemNd.verify_unit_val = result
        main_verify_unit_val = result
      }
    })
    // 辅计量-单位参数校验
    itemSt.dan_wei_list.forEach((itemNd) => {
      if (!itemNd.is_zhu_ji_liang) {
        itemNd.verify_unit_val = XEUtils.multiply(main_verify_unit_val, itemNd.zhuan_huan_zhi)
      }
    })
  })

  // 单位组-单价参数校验------------------------------------------
  let default_guige_price_val = ''
  selfData.dan_wei_zu_list.forEach((itemSt) => {
    // 默认单位-单价
    itemSt.dan_wei_list.forEach((itemNd) => {
      if (itemNd.is_mo_ren_dan_wei) {
        default_guige_price_val = XEUtils.multiply(itemNd.verify_unit_val, verifyData.ji_jia_shi_li)
      }
    })
  })
  selfData.dan_wei_zu_list.forEach((itemSt) => {
    // 所有单位-单价
    itemSt.dan_wei_list.forEach((itemNd) => {
      itemNd.verify_price_val = XEUtils.divide(default_guige_price_val, itemNd.verify_unit_val)
    })
  })
}

// 行类名计算，实现按 id 分组的斑马纹效果
let getTableCellClassName = (tableData, rowData, field = 'id') => {
  let groupIndexMap = {}
  let currentGroupIndex = 0
  let lastBillCode = null

  // 遍历所有数据，为每个 id 分配分组索引
  tableData.forEach((item, index) => {
    if (item[field] !== lastBillCode) {
      lastBillCode = item[field]
      currentGroupIndex++
    }
    groupIndexMap[index] = currentGroupIndex
  })

  // 根据分组索引的奇偶性返回斑马纹类名
  return groupIndexMap[rowData.rowIndex] % 2 === 0 ? 'table-row-striped' : ''
}

// 计算单件零件数量
/***
 * a 原料
 * b 零件
 * params aSpac 规格-原料 如管：10*1*6000；如板：2000*1000*1
 * params bSpac 规格-零件 如管：10*1*580；如板：280*180*1
 * return 单支(张)零件数量
 */
let getSinglePartCount = (aSpac, bSpec) => {
  let result = 1

  // 获取规格数组，并从大到小排序
  let aList = aSpac
    .split('*')
    .map((item) => Number(item))
    .sort((a, b) => b - a)
  let bList = bSpec
    .split('*')
    .map((item) => Number(item))
    .sort((a, b) => b - a)

  let isSameLen = aList.length === bList.length
  if (isSameLen) {
    // 返回a和b不相等的数组
    let aNotSameList = aList.filter((item, index) => item !== bList[index])
    let bNotSameList = bList.filter((item, index) => item !== aList[index])
    let notSameCount = aNotSameList.length
    // 对比不相等的个数，如果有1个，则为管的同类，如果有两个，则为板的同类
    if (notSameCount === 1) {
      // 管类，直接除
      console.log(aNotSameList[0], bNotSameList[0])
      result = XEUtils.floor(XEUtils.divide(aNotSameList[0], bNotSameList[0]))
    } else if (notSameCount === 2) {
      // 板类
      let resultSort0 = getCutCount(aNotSameList, bNotSameList, '先顺后逆方案') // 长宽顺向，切割数量
      let resultSort1 = getCutCount(aNotSameList.reverse(), bNotSameList, '先逆后顺方案') // 长宽换向，切割数量(旋转90度)
      result = XEUtils.max([resultSort0, resultSort1]) // 取最优值
    }
  }
  return result
}

// 获取切割数量
let getCutCount = (aNotSameList, bNotSameList, logStr) => {
  // 0、零件不旋转-切宽数量
  // 1、零件不旋转-切长数量
  let c_x = XEUtils.floor(XEUtils.divide(aNotSameList[0], bNotSameList[0])) // 数量-x轴
  let c_y = XEUtils.floor(XEUtils.divide(aNotSameList[1], bNotSameList[1])) // 数量-y轴
  let resultX = XEUtils.multiply(c_x, c_y)
  let resultY = 0

  let w_x = aNotSameList[0] % bNotSameList[0] // 尾料-x轴
  let w_y = aNotSameList[1] // 尾料-y轴(和原料长度一样，不需要变)
  let canRotate = w_x >= bNotSameList[1] && w_y >= bNotSameList[0] // 判断是否可以旋转90度切
  if (canRotate) {
    c_x = XEUtils.floor(XEUtils.divide(w_x, bNotSameList[1])) // 2、零件旋转90度-切宽数量
    c_y = XEUtils.floor(XEUtils.divide(w_y, bNotSameList[0])) // 3、零件旋转90度-切长数量
    resultY = XEUtils.multiply(c_x, c_y)
  }

  // 输出结果
  let result = XEUtils.add(resultX, resultY)
  console.log(`${logStr}：${result} = ${resultX} + ${resultY}`)

  return result
}

let tool = {
  hasControl,
  tableChoosePrompt,
  autoGenerate,
  useEnSymbolFenGe,
  getDanWei,
  getMergeCellConfigList,
  getMergeCellAll,
  getMergeCountListByName,
  getListStr,
  getJiaoHuoDateStatus,
  listAddTotal,
  gongShiResult,
  hasBracket,
  actionVerify,
  getTableCellClassName,
  getSinglePartCount,
  getCutCount
}

export default tool
